import { render, staticRenderFns } from "./colonyMap.vue?vue&type=template&id=5bba752c&"
import script from "./colonyMap.vue?vue&type=script&lang=ts&"
export * from "./colonyMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports